<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success">{{ message.text }}</message-component>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <label-component fontSize="35" fontWeight="bold" style="margin-top: 30px; margin-bottom:50px;">パスワード再設定</label-component>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <p class="text-center explanatory_text">
                入力されたメールアドレスに<br />
                パスワード再設定のURLを送信します。
                </p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <label-component>メールアドレス</label-component>
            </v-col>
            <v-col cols="12" xl="3">
                <ValidationProvider rules="required|email" v-slot="{ errors }">
                    <v-text-field outlined clearable v-disabled-icon-focus v-model="email" :error-messages="errors" background-color="white"></v-text-field>
                </ValidationProvider>
            </v-col>
            <v-col cols="12" xl="2">
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <button-component block @click="password_reset">送信</button-component>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                email: null,
                 // メッセージ
                message: {
                    success: false,
                    text: '',
                },
            }
        },
        methods: {
            password_reset: async function (event) {
                var res = await axios.post(
                    '/documents/password_reset',
                    {
                        'email': this.email,
                    }
                )
                .catch(res => {
                  // console.log(res);
                    this.message.success = false;
                    this.message.text = "処理に失敗しました";
                });
                if (res.data.message) {
                    this.message.success = res.data.success;
                    this.message.text = res.data.message;
                }
                if (res.data.success) {
                    if ('redirect' in res.data) {
                        window.location = res.data.redirect;
                    } else {
                        window.location = "/documents/password_reset_complete";
                    }
                }
            }
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
    }
</script>
<style scoped>
    .explanatory_text {
        font-size: 16px;
    }
</style>